export enum CoherentScreenProperties {
  Name = 'name',
  Description = 'description',
  OrderedReferenceList = 'orderedReferenceList',
  CuratedMediaLists = 'curatedMediaLists',
  CuratedSeriesLists = 'curatedSeriesLists',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  LastUpdatedBy = 'lastUpdatedBy',
  HighlightSeriesId = 'highlightSeriesId',
  ProcessedSeries = 'processedSeries',
  ProcessedMedia = 'processedMedia',
}
export enum CoherentScreenMetaProperties {
  CuratedMediaListsId = 'CuratedMediaLists-id',
  CuratedMediaListsVersion = 'CuratedMediaLists-version',
  CuratedSeriesListsId = 'CuratedSeriesLists-id',
  CuratedSeriesListsVersion = 'CuratedSeriesLists-version',
}
